"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HeaderVideoTitle;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("./Button.js"));

var _Skew = _interopRequireDefault(require("./Skew.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// components
function HeaderVideoTitle(_ref) {
  var video = _ref.video,
      title = _ref.title,
      subtitle = _ref.subtitle,
      buttonText = _ref.buttonText,
      buttonIcon = _ref.buttonIcon,
      buttonColor = _ref.buttonColor,
      skew = _ref.skew;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "p-0 flex items-center overflow-hidden relative bg-black min-h-screen-75"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "absolute w-full bg-indigo-500 h-full z-1 opacity-30 top-0 left-0"
  }), /*#__PURE__*/_react.default.createElement("video", {
    playsInline: "playsinline",
    autoPlay: "autoplay",
    muted: "muted",
    loop: "loop",
    className: "absolute min-w-full max-w-none min-h-full z-0 transform -translate-x-1/2 -translate-y-1/2 top-7/20 left-1/2"
  }, /*#__PURE__*/_react.default.createElement("source", {
    src: video,
    type: "video/mp4"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "container mx-auto px-4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "relative text-center flex flex-wrap -mx-4 z-1"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mx-auto px-4 relative w-full lg:w-8/12"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "text-4xl font-semibold leading-tight text-white"
  }, title), /*#__PURE__*/_react.default.createElement("h4", {
    className: "mt-2 text-lg text-white opacity-75 mb-8"
  }, subtitle), /*#__PURE__*/_react.default.createElement(_Button.default, {
    color: buttonColor,
    size: "lg"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: buttonIcon + " mr-2"
  }), buttonText)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full absolute text-white bottom-0 z-1"
  }, /*#__PURE__*/_react.default.createElement(_Skew.default, skew))));
}

HeaderVideoTitle.defaultProps = {
  skew: {}
};
HeaderVideoTitle.propTypes = {
  video: _propTypes.default.string.isRequired,
  title: _propTypes.default.string.isRequired,
  subtitle: _propTypes.default.string.isRequired,
  buttonText: _propTypes.default.string.isRequired,
  buttonIcon: _propTypes.default.string,
  buttonColor: _propTypes.default.oneOf(["light", "dark", "blueGray", "red", "orange", "amber", "emerald", "teal", "lightBlue", "indigo", "purple", "pink"]),
  // props to pass to the Skew component
  skew: _propTypes.default.object
};
